import { useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function NotFound() {
  useEffect(() => {
    document.title = 'Page not found | Morrow People';
  }, []);

  return (
    <main className="flex-1 min-h-screen flex flex-col items-center justify-center text-center px-5 bg-background-50">
      <Link to="/" className="font-display font-semibold text-[30px] text-accent-500 cursor-pointer focus-ring">MORROW</Link>
      <p className="mt-10 font-label text-[12px] tracking-[0.2em] text-foreground-600">ERROR 404</p>
      <h1 className="mt-4 font-display font-normal text-[clamp(2rem,3.4vw,3rem)] leading-[1.1] text-foreground-950">
        This page could not be found.
      </h1>
      <p className="mt-4 max-w-md text-[16px] leading-[1.6] text-foreground-700">
        The link may be outdated or the address mistyped. Let&apos;s take you somewhere useful.
      </p>
      <Link
        to="/"
        className="group mt-8 inline-flex items-center gap-2 bg-primary-500 text-background-50 hover:bg-accent-500 transition-colors duration-[240ms] ease-ui focus-ring px-6 py-3.5 font-label text-[15px] font-medium whitespace-nowrap cursor-pointer"
      >
        Back to home <i className="ri-arrow-right-up-line arrow-nudge"></i>
      </Link>
    </main>
  );
}